let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("ibJV0")).then(() => parcelRequire('cHxvv'));